import React from 'react';
import PropTypes from 'prop-types';
import { Select as TWSelect } from 'twyne-new.ui';
import { useProps } from 'components/pure/hooks';

const propTypes = TWSelect.propTypes
const imutableProps = {}
const mutableProps = {}

export default function Async({ children, ...props }) {
  return <TWSelect {...useProps(props, imutableProps)} async children={children} />
}

Async.propTypes = propTypes
Async.defaultProps = mutableProps